import { getRetailUnitAndLanguage } from './getRetailUnitAndLanguage';

export const getRetailUnitCookiePath = `/${getRetailUnitAndLanguage().retailUnit}/`;
